import toastr from "toastr";
import "../../node_modules/toastr/toastr.scss";

//Options
toastr.options.closeButton = true;
toastr.options.closeHtml = '<i class="flaticon2-cross  icon-xs"></i>';
toastr.options.closeClass = "toastr-close-button-custom";

toastr.options.showMethod = "fadeIn";
toastr.options.hideMethod = "fadeOut";
toastr.options.closeMethod = "fadeOut";

toastr.options.timeOut = 3500;
toastr.options.extendedTimeOut = 1500;

toastr.options.newestOnTop = true;
toastr.options.preventDuplicates = true;
toastr.options.positionClass = "toast-bottom-right";

export default toastr;
